// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon[class*="icon-svg-"].no-margin > svg {
  margin: 0 !important;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./wp_components/core/Icon/index.less"],"names":[],"mappings":"AAAA;EACI,oBAAA;ACCJ;AACA,oCAAoC","sourcesContent":[".icon[class*=\"icon-svg-\"].no-margin > svg {\n    margin: 0 !important;\n}",".icon[class*=\"icon-svg-\"].no-margin > svg {\n  margin: 0 !important;\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
